export const environment = {
  production: false,
  apiUrl: 'https://scaniavanguardapidev.cloud.delega.co/vanguard/api/',
  apiKey: 'vaZaXEuxzrhGBkENCMjwBSy29N7H1IXvf2MKMWW7p4mGWcZOTtRgHAKIi8o344cF',
  azureADSignInUri: 'https://scanialogin-pruebas.clouddelega.com/Account/SignInAzureAD',
  deepLinkScheme: 'scaniavanguard',
  uniqueAccessAppName: 'VanGuard',
  selectorValuesUrls: {
    es: 'https://vanguardev.blob.core.windows.net/vanguardev/InternalFiles/selector-values-es.json',
    pt: 'https://vanguardev.blob.core.windows.net/vanguardev/InternalFiles/selector-values-pt.json'
  },
  clientsUrl: 'https://vanguardev.blob.core.windows.net/vanguardev/InternalFiles/clients.json'
};
